<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="80px"
    >
      <el-row v-if="dataAttrArr.indexOf('coalNumber')>-1">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="车数量"
              prop="coalNumber"
              style="margin-right:15px"
            >
              <el-input
                v-model="form.coalNumber"
                placeholder="请输入车数量"
                @input="(value)=>formFormatter.isInteger(value,oldValue,form, 'coalNumber')"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="dataAttrArr.indexOf('perWeight')>-1">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="车载数量"
              prop="perWeight"
              style="margin-right:15px"
            >
              <el-input
                v-model="form.perWeight"
                type="number"
                placeholder="请输入车载数量"
                @input="(value)=>{setWeight(value,'perWeight',coalUnitName)}"
              />{{ coalUnitName }}
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="dataAttrArr.indexOf('bidCount')>-1">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="车数量"
              prop="bidCount"
              style="margin-right:15px"
            >
              <el-input
                v-model="form.bidCount"
                type="number"
                placeholder="请输入车数量"
                @input="(value)=>{form.bidCount = value.replace(/\.[0-9]+/,'')}"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="dataAttrArr.indexOf('bidWeight')>-1">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="每车数量"
              prop="bidWeight"
              style="margin-right:15px"
            >
              <el-input
                v-model="form.bidWeight"
                type="number"
                placeholder="请输入每车数量"
                @input="(value)=>{setWeight(value,'bidWeight',coalUnitName)}"
              />{{ coalUnitName }}
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="dataAttrArr.indexOf('bidPrice')>-1">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="报价单价"
              prop="bidPrice"
              style="margin-right:15px"
            >
              <el-input
                v-model="form.bidPrice"
                placeholder="请输入报价单价"
                @input="(value)=>formFormatter.isFloor2(value,oldValue,form,'bidPrice')"
              />{{ isTrunkName }}
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="dataAttrArr.indexOf('arrivalTime')>-1">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="到达时间"
              prop="arrivalTime"
              style="margin-right:15px"
            >
              <el-date-picker
                v-model="form.arrivalTime"
                type="datetime"
                placeholder="选择到达时间"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        :disabled="isSubmit"
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
  import {takeOrder, takeOrderBatch, bidOrder, bidOrderBatch} from '@/api/orderform'

  export default {
    name: 'OrderAdd',
    data() {
      return {
        funcS:'',
        dataAttrArr: [],
        entity: {},
        lastCoalNumber: '',
        coalUnitName: '',
        isTrunkName: '',
        isSubmit:false,
        submitTime:0,
        form: {
          mainOrderCode: '',
          perWeight: '',
          coalNumber: '',
          bidCount: '',
          bidWeight: '',
          bidPrice: '',
          arrivalTime: ''
        },
        rules: {
          coalNumber: [
            {required: true, message: '请输入车数量', trigger: 'blur'}
          ],
          bidCount: [
            {required: true, message: '请输入车数量', trigger: 'blur'}
          ],
          perWeight: [
            {required: true, message: '请输入车载数量', trigger: 'blur'}
          ],
          bidWeight: [
            {required: true, message: '请输入每车数量', trigger: 'blur'}
          ],
          bidPrice: [
            {required: true, message: '请输入报价单价', trigger: 'blur'}
          ],
          arrivalTime: [
            {required: true, message: '选择到达时间', trigger: 'blur'}
          ]
        }
      }
    },
    created() {

    },
    methods: {
      // 设置货物数量
      setWeight(value,key,name){
        if(name=='件'){
          this.formFormatter.isInteger(value,this.oldValue,this.form,key)
        }
        else{
          this.formFormatter.isFloor3(value,this.oldValue,this.form,key)
        }
      },
      init(entity, dataAttrArr, funcS) {
        this.$set(this, 'dataAttrArr', dataAttrArr);
        this.funcS = funcS;
        this.lastCoalNumber = entity.lastCoalNumber;
        this.coalUnitName = entity.coalUnitName;
        this.isTrunkName = entity.isTrunkName;
        this.form.mainOrderCode = entity.code;
        this.isSubmit = false;
        this.$refs.form.resetFields();
      },
      submitStatusHandler(status){
        let now = new Date();
        let statusHoldTimes = 600;
        if(status){
          this.submitTime=now.getTime();
          this.isSubmit = status;
        }else{
          let $this = this;
          setTimeout(function(){
            $this.isSubmit = status;
          },statusHoldTimes);
        }
      },
      // 提交
      funcSubmit() {
        if(!this.isSubmit){
          const rLoading = this.openLoading();
          // 报价单
          this.$refs['form'].validate((valid) => {
            if (valid) {
              this.submitStatusHandler(true);
              const data = this.form
              switch (this.funcS) {
                case 'TO':
                  takeOrder(data).then(response => {
                    this.$message({ message: response.msg, type: 'success' })
                    this.$emit('fatherTakeMethod')
                  },response=>{
                    this.submitStatusHandler(false);
                  });
                  break;
                case 'TOB':
                  takeOrderBatch(data).then(response => {
                    this.$message({ message: response.msg, type: 'success' })
                    this.$emit('fatherTakeMethod')
                  },response=>{
                    this.submitStatusHandler(false);
                  });
                  break;
                case 'BO':
                  bidOrder(data).then(response => {
                    this.$message({ message: response.msg, type: 'success' })
                    this.$emit('fatherTakeMethod')
                  },response=>{
                    this.submitStatusHandler(false);
                  });
                  break;
                case 'BOB':
                  bidOrderBatch(data).then(response => {
                    this.$message({ message: response.msg, type: 'success' })
                    this.$emit('fatherTakeMethod')
                  },response=>{
                    this.submitStatusHandler(false);
                  });
                  break;
              }
            } else {
              return false;
            }
          });
          rLoading.close();
        }
      },
      // 取消
      funcCancel() {
        this.$emit('fatherCancelMethod', 'take')
      }
    }
  }
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin: 15px 0 15px 0;
    width: 175px;
    float: right;
  }
  .el-input{
    width:160px;
    margin-right:10px;
  }
  .el-date-editor{
    width:unset;
  }
</style>
